import { Button, Modal } from 'antd';
import React from 'react';

const CommonBulkConfirmationModal = ({
  showModal = false,
  setShowModal,
  onConfirm,
  loading = false,
  title = 'Unsaved Changes',
  message = 'Your changes are not saved. Do you want to discard them?',
}) => {
  const handleCancel = () => {
    setShowModal(false);
  };

  const handleConfirm = () => {
    onConfirm?.();
    handleCancel();
  };

  return (
    <Modal
      className="confirmation-modal"
      maskClosable={false}
      centered
      closable={false}
      footer={null}
      open={showModal}
      onOk={handleConfirm}
      onCancel={handleCancel}
    >
      <h2>{title}</h2>
      <p>{message}</p>
      <div className="form-buttons">
        <Button
          shape="round"
          className="cancel-button"
          onClick={handleCancel}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          shape="round"
          type="primary"
          className="save-button"
          onClick={handleConfirm}
          loading={loading}
        >
          Discard
        </Button>
      </div>
    </Modal>
  );
};

export default CommonBulkConfirmationModal;
